import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { AsyncLocalStorageModule } from "angular-async-local-storage";
import { AmazingTimePickerModule } from "amazing-time-picker";
import { EventsModule } from "angular4-events";
import { ChartsModule } from "ng4-charts/ng4-charts";
import { TimezonePickerModule } from "ng2-timezone-selector";
import { MyDatePickerModule } from "mydatepicker";
// import { PubSubModule } from 'angular2-pubsub';
import { SortablejsModule } from "angular-sortablejs";
import { AuthenticationService } from "./authentication.service";
import { DataService } from "./data.service";
import { CountryService } from "./country.service";
import { ImageCropperModule } from "ngx-image-cropper";
import { ProgressBarModule } from "angular-progress-bar";


import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { FooterComponent } from "./footer/footer.component";
import { CutomersComponent } from "./cutomers/cutomers.component";
import { DriversComponent } from "./drivers/drivers.component";
import { OutletsComponent } from "./outlets/outlets.component";
import { AddCustomerComponent } from "./add-customer/add-customer.component";
import { AddOutletComponent } from "./add-outlet/add-outlet.component";
import { AddDriverComponent } from "./add-driver/add-driver.component";
import { DriverDetailComponent } from "./driver-detail/driver-detail.component";
import { CustomerDetailComponent } from "./customer-detail/customer-detail.component";
import { DispensaryDetailComponent } from "./dispensary-detail/dispensary-detail.component";
import { ReportsComponent } from "./reports/reports.component";
import { SupportComponent } from "./support/support.component";
import { StoreComponent } from "./store/store.component";
import { DriverReportDetailComponent } from "./driver-report-detail/driver-report-detail.component";
import { UserReportDetailComponent } from "./user-report-detail/user-report-detail.component";
import { CategoriesComponent } from "./categories/categories.component";
import { VendorComponent } from "./vendor/vendor.component";
import { BusinessCategoryComponent } from "./business-category/business-category.component";
import { SettingsComponent } from "./settings/settings.component";
import { PendingDriverComponent } from "./pending-driver/pending-driver.component";
import { BillingComponent } from "./billing/billing.component";
import { AccountStatementComponent } from "./account-statement/account-statement.component";
import { StoryComponent } from "./story/story.component";
import { AddStoryComponent } from "./add-story/add-story.component";
import { StoryDetailComponent } from "./story-detail/story-detail.component";
import { CardPaymentComponent } from "./card-payment/card-payment.component";
import { WithdrawComponent } from "./withdraw/withdraw.component";
import { LogsComponent } from "./logs/logs.component";
import { CustomerAddressListingComponent } from "./customer-address-listing/customer-address-listing.component";
import { EditCustomerAddressComponent } from "./edit-customer-address/edit-customer-address.component";
import { CustomerAddAddressComponent } from "./customer-add-address/customer-add-address.component";
import { PackgesComponent } from "./packges/packges.component";
import { CustomOrderComponent } from "./custom-order/custom-order.component";
import { EventsComponent } from "./events/events.component";
import { FaqsComponent } from "./faqs/faqs.component";
import { OrderListingComponent } from "./order-listing/order-listing.component";
import { CreateOrderComponent } from "./create-order/create-order.component";
import { OrderEditComponent } from "./order-edit/order-edit.component";
import { BusinessRolesComponent } from "./business-roles/business-roles.component";
import { AuthGuard } from "./auth.guard";
import { RegisteredVendorsComponent } from "./registered-vendors/registered-vendors.component";
import { AddRegisteredVendorComponent } from "./add-registered-vendor/add-registered-vendor.component";
import { BsDatepickerModule } from "ngx-bootstrap";
import { CardModule } from "ngx-card/ngx-card";
import { RatingsComponent } from "./ratings/ratings.component";
import { ChainsComponent } from "./chains/chains.component";
import { ForcedDropoffComponent } from "./forced-dropoff/forced-dropoff.component";
import { SubscriptionsComponent } from "./subscriptions/subscriptions.component";
import { ImportProductsComponent } from "./import-products/import-products.component";
import { ColorPickerModule } from "ngx-color-picker";
import { ExcelService } from "./excel.service";
import { ChatModalComponent } from "./modals/chat-modal/chat-modal.component";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ImagePreviewComponent } from "./modals/image-preview/image-preview.component";
import { SearchBuisnessPipe } from './pipes/search-buisness.pipe';
import { ReportProblemComponent } from './report-problem/report-problem.component';
import { ProblemDetailComponent } from './problem-detail/problem-detail.component';
import { NoNegativeDirective } from './shared/no-negative.directive';

const appRoute: Routes = [
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [2],
    },
  },
  {
    path: "customers",
    component: CutomersComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "customers/:id",
    component: CutomersComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "customer-detail/:id",
    component: CustomerDetailComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "add-customers",
    component: AddCustomerComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "customer-add-address/:id",
    component: CustomerAddAddressComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "edit-customer-address/:id",
    component: EditCustomerAddressComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [3],
    },
  },
  {
    path: "drivers",
    component: DriversComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [4],
    },
  },
  {
    path: "add-driver",
    component: AddDriverComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [4],
    },
  },
  {
    path: "driver-detail/:id",
    component: DriverDetailComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [4],
    },
  },
  {
    path: "dispensaries",
    component: OutletsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [10],
    },
  },
  {
    path: "add-dispensary",
    component: AddOutletComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [10],
    },
  },
  {
    path: "dispensary-detail/:id",
    component: DispensaryDetailComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [10],
    },
  },
  // {
  //   path: 'driver-earning-detail/:id',
  //   component: DriverReportDetailComponent,
  // },
  // {
  //   path: 'user-spending-detail/:id',
  //   component: UserReportDetailComponent,
  // },
  { path: "reports", component: ReportsComponent },
  {
    path: "support",
    component: SupportComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [14],
    },
  },
  {
    path: "store",
    component: StoreComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [13],
    },
  },
  {
    path: "categories",
    component: CategoriesComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [7],
    },
  },
  {
    path: "vendors",
    component: VendorComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [9],
    },
  },
  {
    path: "business-categories",
    component: BusinessCategoryComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [8],
    },
  },
  {
    path: "settings",
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [21],
    },
  },
  {
    path: "billing",
    component: BillingComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [15],
    },
  },
  {
    path: "story",
    component: StoryComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [11],
    },
  },
  {
    path: "add-story",
    component: AddStoryComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [11],
    },
  },
  {
    path: "story-detail/:id",
    component: StoryDetailComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [11],
    },
  },
  {
    path: "pending_driver",
    component: PendingDriverComponent,
    data: {
      allowedRoles: [4],
    },
  },
  {
    path: "account-statement/:id",
    component: AccountStatementComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [10],
    },
  },
  {
    path: "payments",
    component: CardPaymentComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [16],
    },
  },
  {
    path: "withdraw",
    component: WithdrawComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [17],
    },
  },
  {
    path: "logs",
    component: LogsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [18],
    },
  },
  {
    path: "packges",
    component: PackgesComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [12],
    },
  },
  // {
  //   path: "order-request",
  //   component: CustomOrderComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     allowedRoles: [5],
  //   },
  // },
  {
    path: "events",
    component: EventsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [19],
    },
  },
  {
    path: "faqs",
    component: FaqsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [20],
    },
  },
  {
    path: "order-listing",
    component: OrderListingComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [6],
    },
  },
  {
    path: "subscriptions",
    component: SubscriptionsComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: [30]
    // }
  },
  {
    path: "create-order",
    component: CreateOrderComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [6],
    },
  },
  {
    path: "order-edit/:id",
    component: OrderEditComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [6],
    },
  },
  {
    path: "business-roles",
    component: BusinessRolesComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [22],
    },
  },
  {
    path: "refresh-component",
    component: SidebarComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [4],
    },
  },
  {
    path: "add-registered-vendors",
    component: AddRegisteredVendorComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [24],
    },
  },
  {
    path: "registered-vendors",
    component: RegisteredVendorsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [25],
    },
  },
  {
    path: "ratings",
    component: RatingsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [26],
    },
  },
  {
    path: "chains",
    component: ChainsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [28],
    },
  },
  {
    path: "Dropoff",
    component: ForcedDropoffComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [29],
    },
  },
  {
    path: "import-products",
    component: ImportProductsComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: [20],
    },
  },
  {
    path: "report-problem",
    component: ReportProblemComponent,
  },

    {
      path: "report-problem/:id",
      component: ProblemDetailComponent,
    }

];
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    CutomersComponent,
    AddCustomerComponent,
    DriversComponent,
    AddDriverComponent,
    OutletsComponent,
    AddOutletComponent,
    DriverDetailComponent,
    CustomerDetailComponent,
    DispensaryDetailComponent,
    ReportsComponent,
    SupportComponent,
    StoreComponent,
    DriverReportDetailComponent,
    UserReportDetailComponent,
    CategoriesComponent,
    VendorComponent,
    BusinessCategoryComponent,
    SettingsComponent,
    PendingDriverComponent,
    BillingComponent,
    AccountStatementComponent,
    StoryComponent,
    AddStoryComponent,
    StoryDetailComponent,
    CardPaymentComponent,
    WithdrawComponent,
    LogsComponent,
    CustomerAddressListingComponent,
    EditCustomerAddressComponent,
    CustomerAddAddressComponent,
    PackgesComponent,
    CustomOrderComponent,
    EventsComponent,
    FaqsComponent,
    OrderListingComponent,
    CreateOrderComponent,
    OrderEditComponent,
    BusinessRolesComponent,
    RegisteredVendorsComponent,
    AddRegisteredVendorComponent,
    RatingsComponent,
    ChainsComponent,
    ForcedDropoffComponent,
    SubscriptionsComponent,
    ImportProductsComponent,
    ChatModalComponent,
    ImagePreviewComponent,
    SearchBuisnessPipe,
    ReportProblemComponent,
    ProblemDetailComponent,
    NoNegativeDirective,
  ],
  entryComponents: [ChatModalComponent, ImagePreviewComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AsyncLocalStorageModule,
    RouterModule.forRoot(appRoute),
    SortablejsModule.forRoot({ animation: 150 }),
    AmazingTimePickerModule,
    EventsModule,
    ChartsModule,
    TimezonePickerModule,
    MyDatePickerModule,
    ImageCropperModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    ProgressBarModule,
    ColorPickerModule,
    // PubSubModule.forRoot(),
    NgbModule.forRoot(),
  ],
  providers: [
    DataService,
    AuthenticationService,
    CountryService,
    HttpClientModule,
    CutomersComponent,
    DriversComponent,
    AuthGuard,
    ExcelService,
    NgbActiveModal,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts